import {
  CompanyAttributes,
  DocumentClassAttributes,
  MaterialStockAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule, DecimalPipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  IPaginationResult,
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  andWhere,
  buildQuery,
  Ops,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import {
  debounceTime,
  distinctUntilChanged,
  lastValueFrom,
  Observable,
} from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { getCode } from "app/utils/method";
import { Router } from "@angular/router";
import { environment } from "environments/environment.prod";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import {
  ExportFileFormat,
  ExportRange,
} from "app/layout/export-overlay/tasks/core/export-task.enum";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MasterUserInterface } from "../../sales/order-generate/interfaces/master-user.interface";
import { AddOrderDetailComponent } from "../../sales/add-order-detail/add-order-detail.component";
import { OrdersCreationService } from "../../sales/order-generate/order-generate.service";
import { CancelOrderComponent } from "../../sales/cancel-order/cancel-order.component";
import { UpdateOrderService } from "../../sales/update-order/update-order.service";
import { IUpdateOrder } from "../../sales/update-order/interfaces/update-order.interface";
import { UpdateOrderComponent } from "../../sales/update-order/update-order.component";
import { OrdersListService } from "../../sales/order-list-components/order-list.service";
import { SelectOrderDetailComponent } from "../../sales/select-order-detail/select-order-detail.component";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { MatTabsModule } from "@angular/material/tabs";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { validateOrdersByActionForPayment } from "app/utils/document-class-validation";
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";

@Component({
  selector: "app-payment-load-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenav,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    MonedaPipe,
    DecimalFormatPipe,
    BusinessPartnerDisplayComponent,
    UnitMeasureDisplayComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
  ],
  templateUrl: "./payment-load-list.html",
  styleUrl: "./payment-load-list.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class PaymentTableListComponent implements OnInit {
  @Input() summaryData: OrderPaymentAttributes[] | null = null;
  @Input() isAllColumns: boolean = true;

  @Input() currency: string = "";
  @Output() refreshMonitor = new EventEmitter();

  getCode = getCode;
  StatusEnum = StatusEnum
  projectName = environment.projectName;

  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    // "type",
    "businessPartner",
    "documentNumber",
    "class",
    //"payment_method",
    // "payment_type",
    //'date',
    "subTotal",
    //'surcharge', 'discount', 'tax',
    "total",
    // "creation",
    // "loadDateTime",
    // 'documentStatus',
    "actions",
  ];
  dataSource = new MatTableDataSource<OrderPaymentAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderPaymentAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderPaymentAttributes | null = null;

  //DETAIL
  displayedColumnsDetail: string[] = [
    "material",
    "note",
    "warehouse",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "tax",
    "total" /*, 'actions'*/,
  ];
  dataSourceDetail = new MatTableDataSource<OrderPaymentAttributes>([]);

  companyList: CompanyAttributes[] = [];

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;
  selectedStatusERP: number = 0;
  selectedDocumentClass: string = "0";
  selectedSeller: string = "0";
  selectedWithTravel: string = "0";

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Enviado a ERP" },
    { id: 2, name: "Recibido por ERP" },
    { id: 3, name: "Creado en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;
  isErpIntegrated = environment.isErpIntegrated;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  companies: CompanyAttributes[] = [];

  // Datos tabs
  dataSourceInnerDetail = new MatTableDataSource<OrderPaymentAttributes>([]);
  dataSourceDocument = new MatTableDataSource<OrderPaymentAttributes>([]);
  displayedColumnsInnerDetail: string[] = [
    // "inner",
    "paymentMethod",
    "bank",
    "operationNumber",
    "paying",
  ];
  displayedColumnsDocument: string[] = [
    "serials",
    "paymentType",
    "document",
    "afecto",
    "pendingPayment",
    "paying",
    "balance",
  ];
  displayedColumnsShip: string[] = ["paymentType", "document", "paying"];

  selectedInner: any | null = null;
  dataSourceShip = new MatTableDataSource<any>([]);

  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly companyService: CompanyService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private exportService: ExportService
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["summaryData"] && this.summaryData) {
      this.dataSource.data = this.summaryData;
      this.displayedColumns = this.isAllColumns
        ? this.displayedColumns
        : [
            "det",
            "check",
            "status",
            "statusERP",
            "type",
            "businessPartner",
            "documentNumber",
            "class",
            //  "payment_method",
            // "payment_type",
            //'date',
            "subTotal",
            //'surcharge', 'discount', 'tax',
            "total",
            // "creation",
            // 'documentStatus',
            "actions",
          ];
    }
  }

  ngOnInit(): void {
    // this.getCompanies().then(() => {
    //   this.onFilter();
    // });
    this.fetchDocumentClass();
    // this.getListSeller();
    if (this.summaryData) {
      this.dataSource.data = this.summaryData.filter(
        (item) => item?.codeReason != "FACTURA_AVE"
      );
    }
  }

  ngAfterViewInit(): void {
    // this.searchControl.valueChanges
    //   .pipe(
    //     debounceTime(500),
    //     distinctUntilChanged()
    //   )
    //   .subscribe((filterValue: string) => {
    //     this.pageIndex = 1;
    //     this.search = filterValue;
    //     this.getList();
    //   });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
  }

  openInterval(event) {
    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }

      this.interval = setInterval(() => {}, this.timeInterval);
    } else {
    }
  }

  //   private getSortField(): keyof OrderPaymentAttributes {
  //     const sortFieldMapping: Record<string, keyof OrderPaymentAttributes> = {
  //       status: "statusERP",
  //       type: "type",
  //       trip: <any>"trip.id",
  //       subRoute: <any>"subRoute.name",
  //       user: <any>"user.user_login.username",
  //       soldTo: <any>"soldTo.name",
  //       documentNumber: "serial",
  //       class: <any>"class.name",
  //       date: "deliveryDateTime",
  //       creation: "creationDateTime",
  //     };
  //     return sortFieldMapping[this.sortActive] || "creationDateTime";
  //   }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    // this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
  }

  resetSelection() {
    this.selection.clear();
  }

  groupDocument(data): any {
    return [
      {
        serials: data.serials,
        documentType: data.codeReason,
        document: data.document,
        creditNoteNumber: data.creditNoteNumber,
        pendingPayment: data.pendingPayment,
        paying: data.paying,
        balance: data.balance,
        paymentType: data.paymentType,
      },
    ];
  }

  groupOrders(data): any {
    return [
      {
        id: data.paymentType._id,
        bank: data.paymentType.bank,

        accountNumber: data.paymentType.accountNumber,
        orders: [
          {
            documentType: data.codeReason,
            document: data.document,
            paying: data.paying,
          },
        ],
        paymentType: data.paymentType.paymentMethod,
        operationNumber: data.operationNumber,
        paying: data.paying,
      },
    ];
  }

  async toggleDetails(order: OrderPaymentAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder?._id === order?._id) {
      this.selectedOrder = null; // Colapsar la fila si ya está expandida
    } else {
      this.selectedOrder = order; // Expandir la fila
      this.dataSourceInnerDetail.data = [];
      this.dataSourceInnerDetail.data = this.groupOrders(order);
      this.dataSourceDocument.data = this.groupDocument(order);
      //this.cdr.detectChanges();
    }

    //  this.selectedOrder = order;
    //  this.dataSourceDetail.data = this.selectedOrder.detail || [];

    //  // Obtiene compañía para hacer uso de flags
    //  const companyFound: CompanyAttributes = this.companies.find(
    //    (c) => c.id == this.selectedOrder.company?.id
    //  );
    //  if (companyFound) this.selectedOrder.company = companyFound;

    //  // Obtiene almacenes y clase de documento
    //  const orderStatusId = this.selectedOrder.statusId;
    //  if (orderStatusId != 0 && orderStatusId != 7 && orderStatusId != 8) {
    //    await this.getDocumentClass(this.selectedOrder);

    //    if (
    //      this.selectedOrder.class["showCurrentStockForMaterials"] == true &&
    //      !this.selectedOrder["warehousesToUpdate"]
    //    ) {
    //      const salesOffice: Partial<SalesOfficeAttributes> = await lastValueFrom(
    //        this.salesOfficeService.findOne(
    //          this.selectedOrder.salesOffice._id.toString()
    //        )
    //      ).then((res) => res.data);
    //      if (salesOffice && salesOffice.warehouses) {
    //        let filter = {
    //          officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
    //          company: [environment.companyId],
    //        };
    //        this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
    //          this.warehouseService.filterComboBox(filter)
    //        ).then((res) => res.data);
    //        this.getStock(
    //          this.selectedOrder,
    //          this.selectedOrder["warehousesToUpdate"]
    //        );
    //      }
    //    }
    //  }
  }

  toggleInner(detail: any): void {
    if (this.selectedInner && this.selectedInner?.id === detail?.id) {
      this.selectedInner = null;
    } else {
      this.selectedInner = detail;
      this.dataSourceShip.data = detail.orders;
    }
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  onCompanySelectionChange(companyid: string): void {
    /*if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }*/
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: today, end: today });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedStatusERP = 0;
    this.selectedDocumentClass = "0";
    this.selectedSeller = "0";
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  async getCompanies(): Promise<void> {
    this.companies = [];
    await lastValueFrom(this.companyService.fetchCompanyByEnvIds())
      .then((res) => {
        this.companies = res.data;
      })
      .catch((err) => {
        this.snackBar.open(err.error.message, "Cerrar", { duration: 3000 });
      });
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: DocumentTypeEnum.DOCUMENTO_DE_PAGO,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vendedores.","Cerrar",{ duration: 5000});
      },
    });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"}`;
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToSynchronize(row)
    );
    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected === numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (this.validateDataToSynchronize(row)) this.selection.select(row);
        });
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
        0;
  }

  synchronizeOrders(order: OrderPaymentAttributes) {
    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
    };

    if (order) {
      if (order?.externalKeys?.code) {
        dataToSendPut.orderIds.push(order._id.toString());
      } else {
        dataToSendPost.orderIds.push(order._id.toString());
      }
    } else {
      this.selection.selected.forEach((o) => {
        if (o.externalKeys?.code) {
          dataToSendPut.orderIds.push(o._id.toString());
        } else {
          dataToSendPost.orderIds.push(o._id.toString());
        }
      });
    }

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if(requests.length === 0) {
      this.snackBar.open("No se encontraron registros pendientes de sincronizar con ERP.","Cerrar",{ duration: 5000});
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.refreshMonitor.emit();
        // this.getList();
      })
      .catch((err) => {
        this.snackBar.open(err.error.message || "Error al sincronizar con el ERP.","Cerrar",{ duration: 5000});
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  generateOrder(element) {
    let object = {
      quoteId: element._id,
    };
    this.router.navigate(["master", "sales", "order-generate"], {
      queryParams: object,
    });
  }

  onChangeSubTotalInOrderDetail(
    order: OrderPaymentAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }


  validateDataToSynchronize(order: OrderPaymentAttributes) {
    return validateOrdersByActionForPayment([order], this.documentClassesList, 'SYNC')
  }
}
